export const WorkflowConditionKeys = [
  'skip_re_login',
  //more condition keys can be added here
] as const;

export type WorkflowConditionKey = (typeof WorkflowConditionKeys)[number];

export const WORKFLOW_CONDITION_SKIP_RE_LOGIN: WorkflowConditionKey = 'skip_re_login';
